<template>
  <div class="box">
    <van-icon class="icon" size="100px" color="#64b41e" name="checked" />
    <div class="status">支付成功</div>
    <van-button @click="submit" type="primary" block class="btn">付款成功，可在"我的订单"查看</van-button>
  </div>
</template>

<script>
import { reactive, toRefs, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

export default {
  setup() {
    let router = useRouter()
    const state = reactive({
      count: 0
    })
    let timeout = ''
    const submit = () => {
      let mchData = {
        action: 'jumpOut',
        jumpOutUrl: location.origin + location.pathname + '#/orderList?status=2' //跳转的页面
      }
      let postData = JSON.stringify(mchData)
      parent.postMessage(postData, 'https://payapp.weixin.qq.com')
      let payAway = localStorage.getItem('payAway')
      if (payAway === 'alipay') {
        router.push({
          path: '/orderList',
          query: {
            status: 2,
            event: '支付成功跳转订单列表'
          }
        })
      }
    }
    onUnmounted(() => {
      clearTimeout(timeout)
      localStorage.removeItem('payAway')
    })
    return {
      ...toRefs(state),
      submit
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 0 20px;
  box-sizing: border-box;
}
.icon {
  margin-top: 20px;
}
.status {
  font-size: 16px;
  font-weight: 600;
  color: #666666;
  margin-top: 24px;
}
.btn {
  margin-top: 40px;
  width: 100%;
}
</style>
